/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RedeemDealRewardBusiness } from './RedeemDealRewardBusiness';
import {
    RedeemDealRewardBusinessFromJSON,
    RedeemDealRewardBusinessFromJSONTyped,
    RedeemDealRewardBusinessToJSON,
} from './RedeemDealRewardBusiness';
import type { RedeemDealRewardDeal } from './RedeemDealRewardDeal';
import {
    RedeemDealRewardDealFromJSON,
    RedeemDealRewardDealFromJSONTyped,
    RedeemDealRewardDealToJSON,
} from './RedeemDealRewardDeal';
import type { RedemptionDeal } from './RedemptionDeal';
import {
    RedemptionDealFromJSON,
    RedemptionDealFromJSONTyped,
    RedemptionDealToJSON,
} from './RedemptionDeal';

/**
 * 
 * @export
 * @interface RedeemDealReward
 */
export interface RedeemDealReward {
    /**
     * 
     * @type {number}
     * @memberof RedeemDealReward
     */
    readonly id: number;
    /**
     * 
     * @type {RedeemDealRewardBusiness}
     * @memberof RedeemDealReward
     */
    business: RedeemDealRewardBusiness;
    /**
     * 
     * @type {RedeemDealRewardDeal}
     * @memberof RedeemDealReward
     */
    deal: RedeemDealRewardDeal;
    /**
     * 
     * @type {Array<RedemptionDeal>}
     * @memberof RedeemDealReward
     */
    readonly deals: Array<RedemptionDeal>;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly description: string;
    /**
     * 
     * @type {number}
     * @memberof RedeemDealReward
     */
    readonly price: number;
    /**
     * 
     * @type {number}
     * @memberof RedeemDealReward
     */
    readonly amount_saved: number;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly image: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemDealReward
     */
    readonly is_archived: boolean;
    /**
     * The ID of the reel associated with this reward. Corresponds to the YouTube video ID.
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly reel_id: string;
    /**
     * The Mux playback ID for the video associated with this reward.
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly mux_playback_id: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly mux_signed_video_token: string | null;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealReward
     */
    readonly mux_signed_thumbnail_token: string | null;
}

/**
 * Check if a given object implements the RedeemDealReward interface.
 */
export function instanceOfRedeemDealReward(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "business" in value;
    isInstance = isInstance && "deal" in value;
    isInstance = isInstance && "deals" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "amount_saved" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "is_archived" in value;
    isInstance = isInstance && "reel_id" in value;
    isInstance = isInstance && "mux_playback_id" in value;
    isInstance = isInstance && "mux_signed_video_token" in value;
    isInstance = isInstance && "mux_signed_thumbnail_token" in value;

    return isInstance;
}

export function RedeemDealRewardFromJSON(json: any): RedeemDealReward {
    return RedeemDealRewardFromJSONTyped(json, false);
}

export function RedeemDealRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemDealReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'business': RedeemDealRewardBusinessFromJSON(json['business']),
        'deal': RedeemDealRewardDealFromJSON(json['deal']),
        'deals': ((json['deals'] as Array<any>).map(RedemptionDealFromJSON)),
        'name': json['name'],
        'description': json['description'],
        'price': json['price'],
        'amount_saved': json['amount_saved'],
        'image': json['image'],
        'is_archived': json['is_archived'],
        'reel_id': json['reel_id'],
        'mux_playback_id': json['mux_playback_id'],
        'mux_signed_video_token': json['mux_signed_video_token'],
        'mux_signed_thumbnail_token': json['mux_signed_thumbnail_token'],
    };
}

export function RedeemDealRewardToJSON(value?: RedeemDealReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business': RedeemDealRewardBusinessToJSON(value.business),
        'deal': RedeemDealRewardDealToJSON(value.deal),
    };
}

